import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderUploadIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 42,
	height: 42,
	viewBox: "0 0 42 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_6002_11058)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M33.4412 3.12109H14.1738V11.1111H37.5563V7.23451C37.5563 4.96616 35.7102 3.12109 33.4412 3.12109Z",
				fill: "#CED9F9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M22.5352 12.3403H0V4.92636C0 2.20972 2.21068 0 4.92828 0H12.1336C12.8497 0 13.5396 0.150925 14.1664 0.434509C15.0418 0.828964 15.7939 1.47913 16.3213 2.3286L22.5352 12.3403Z",
				fill: "#1640C1"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42 14.0004V37.8817C42 40.153 40.1511 42.0003 37.8789 42.0003H4.12111C1.84891 42.0003 0 40.153 0 37.8817V9.88086H37.8789C40.1511 9.88086 42 11.7288 42 14.0004Z",
				fill: "#2354E6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M42 14.0004V37.8817C42 40.153 40.1511 42.0003 37.8789 42.0003H21V9.88086H37.8789C40.1511 9.88086 42 11.7288 42 14.0004Z",
				fill: "#1849D6"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.0471 25.9405C32.0471 32.0329 27.0909 36.9894 20.9991 36.9894C14.9073 36.9894 9.95117 32.0329 9.95117 25.9405C9.95117 19.8491 14.9073 14.8926 20.9991 14.8926C27.0909 14.8926 32.0471 19.8491 32.0471 25.9405Z",
				fill: "#E7ECFC"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M32.0479 25.9405C32.0479 32.0329 27.0918 36.9894 21 36.9894V14.8926C27.0918 14.8926 32.0479 19.8491 32.0479 25.9405Z",
				fill: "#CED9F9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.5612 26.0758C24.3308 26.2709 24.0485 26.3661 23.7688 26.3661C23.4185 26.3661 23.0705 26.2177 22.827 25.9287L22.2307 25.2218V29.8499C22.2307 30.5292 21.6795 31.0803 21.0002 31.0803C20.3209 31.0803 19.7698 30.5292 19.7698 29.8499V25.2218L19.1734 25.9287C18.7344 26.4481 17.9587 26.5145 17.4392 26.0758C16.9201 25.6378 16.8535 24.8617 17.2915 24.3422L19.7271 21.4548C20.0447 21.0793 20.508 20.8633 21.0002 20.8633C21.4924 20.8633 21.9558 21.0793 22.2733 21.4548L24.7089 24.3422C25.147 24.8617 25.0803 25.6378 24.5612 26.0758Z",
				fill: "#6C8DEF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M24.561 26.0758C24.3306 26.2709 24.0483 26.3661 23.7686 26.3661C23.4183 26.3661 23.0703 26.2177 22.8268 25.9287L22.2305 25.2218V29.8499C22.2305 30.5292 21.6793 31.0803 21 31.0803V20.8633C21.4922 20.8633 21.9555 21.0793 22.2731 21.4548L24.7087 24.3422C25.1467 24.8617 25.0801 25.6378 24.561 26.0758Z",
				fill: "#3B67E9"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_6002_11058",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 42,
			height: 42,
			fill: "white"
		})
	}) })]
});
export default SvgFolderUploadIcon;
